import { pxToRem } from "@common/styles/abstracts/utils";
import styled, { css } from "styled-components";

import { vars } from "../../styles";

export const HelperText = styled.div<{
  $marginBottom?: number;
  $marginTop?: number;
}>`
  padding: 7px 9px 6px 7px;

  display: flex;
  gap: 1rem;

  background-color: ${vars.colors.skyLighter};
  border: 1px solid ${vars.colors.skyLighter};
  border-radius: 0.6rem;

  svg,
  path {
    color: ${vars.colors.white} !important;
    stroke: ${vars.colors.transparent} !important;
  }

  a {
    text-decoration: underline;
    color: ${vars.colors.white} !important;
    display: inline;
  }

  p {
    color: ${vars.colors.white} !important;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.8rem;
    display: inline;
  }

  ${({ $marginBottom }) =>
    $marginBottom &&
    css`
      margin-bottom: ${pxToRem($marginBottom)};
    `}
  ${({ $marginTop }) =>
    $marginTop &&
    css`
      margin-top: ${pxToRem($marginTop)};
    `}
`;
